import { render, staticRenderFns } from "./StudySelector.vue?vue&type=template&id=052a7132&"
import script from "./StudySelector.vue?vue&type=script&lang=js&"
export * from "./StudySelector.vue?vue&type=script&lang=js&"
import style0 from "./StudySelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports